import { ChangeDetectionStrategy, Component, ElementRef, OnInit, input } from '@angular/core';
import { CustomDotCmsContentlet } from 'src/app/extensions/dot-cms/models/contentlet/custom-dotcms-contentlet.model';
import { isInsideCarousel } from 'src/app/extensions/dot-cms/utils/dot-cms-utils';

import { GoogleTagManagerFacade } from 'ish-core/facades/gtm.facade';

@Component({
  selector: 'custom-dot-cms-banner-link',
  templateUrl: './dot-cms-banner-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./dot-cms-banner-link.component.scss'],
  standalone: false,
})
export class DotCmsBannerLinkComponent implements OnInit {
  constructor(private elementRef: ElementRef, private gtmFacade: GoogleTagManagerFacade) {}
  readonly contentlet = input<CustomDotCmsContentlet>(undefined);
  readonly animationCss = input<string>(undefined);
  isInCarousel: boolean;
  sku: string;
  ngOnInit(): void {
    this.isInCarousel = isInsideCarousel(this.elementRef.nativeElement);
  }
  /*GTM - Select-Promotion */
  selectPromotionGTMEvent() {
    const contentlet = this.contentlet();
    this.gtmFacade.selectPromotionGTMEvent(contentlet?.link, contentlet);
  }
}
